module.exports = __webpack_public_path__ + "img/story-mode.6f4f31aa.svg";